import { Expose } from "class-transformer";
import type { FeedbackEnum } from "../enums/feedback.enum";
import type { NegativeFeedbackReasonEnum } from "../enums/negative-feedback-reason.enum";
import type { SenderTypeEnum } from "../enums/sender-type.enum";

export interface IConversationMessageDto {
  id: number;
  sessionId: string;
  senderType: SenderTypeEnum;
  message: string;
  feedback: FeedbackEnum | null;
  negativeFeedbackReason: NegativeFeedbackReasonEnum | null;
}

export class ConversationMessageDto implements IConversationMessageDto {
  @Expose()
  id!: number;

  @Expose()
  sessionId!: string;

  @Expose()
  senderType!: SenderTypeEnum;

  @Expose()
  message!: string;

  @Expose()
  feedback: FeedbackEnum | null = null;

  @Expose()
  negativeFeedbackReason: NegativeFeedbackReasonEnum | null = null;
}
